"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Premium = function Premium(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#F54F3F' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 23 26",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m2.714 21.72 4.474-7.75 5.397 3.116-4.474 7.75-1.38-3.842-4.017.725Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m20.735 21.72-4.474-7.75-5.397 3.116 4.474 7.75 1.38-3.842 4.017.725Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB80",
    d: "M10.002 1.36a3.104 3.104 0 0 1 3.686 0l.615.454c.407.3.88.497 1.38.572l.756.114a3.105 3.105 0 0 1 2.607 2.607l.114.756c.076.5.272.973.572 1.38l.454.615a3.105 3.105 0 0 1 0 3.687l-.454.615c-.3.406-.496.88-.572 1.38l-.114.756a3.104 3.104 0 0 1-2.607 2.607l-.755.114c-.5.075-.974.271-1.38.572l-.616.453a3.104 3.104 0 0 1-3.686 0l-.615-.453c-.407-.3-.881-.497-1.38-.572l-.757-.114a3.104 3.104 0 0 1-2.607-2.607l-.114-.756a3.104 3.104 0 0 0-.571-1.38l-.454-.615a3.104 3.104 0 0 1 0-3.687l.454-.615c.3-.407.496-.88.571-1.38l.114-.756A3.104 3.104 0 0 1 7.25 2.5l.756-.114c.5-.075.974-.272 1.38-.572l.616-.454Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.845,
    cy: 9.701,
    r: 6.015,
    fill: "#FFAC33"
  }));
};
var _default = exports["default"] = Premium;